import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/statement/attendance/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 导出
export function downloadExcel(data) {
  return request.send({
    url: `/pmy/sys/driver/statement/attendance/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
